import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import 'rxjs/add/operator/map'
import storage from 'local-storage-fallback';


import {ClientRequest} from  '../../ClientRequest';

@Injectable()
export class CartService {
    constructor(private clientRequest: ClientRequest) {}

    getCart(): Observable<any> {
    	let uid = storage.getItem("uid") ? storage.getItem("uid") : 0;
    	let data = {cart: storage.getItem('cart_id'), id: storage.getItem('cart'), uid: uid};
      	 return this.clientRequest.post( '/carts', data)
            .map((response: HttpResponse<any>) => {
               return response;
        });
    };
    createOrderOnServer(data):Observable<any> {
        return this.clientRequest.post('checkout', data).map((response: HttpResponse<any>) => {
           return response;
        });
    };
}
